import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=e5e30498&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&lang=js&"
export * from "./ReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=e5e30498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e30498",
  null
  
)

export default component.exports